<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="title" placeholder="请输讲师账号或姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <el-table
      ref="multipleeeeTable"
      :data="list"
      tooltip-effect="dark"
      empty-text=""
      style="width: 100%;"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column prop="id" type="selection" width="55"></el-table-column> -->
      <el-table-column label="序号" type="index" width=""></el-table-column>
      <el-table-column prop="userName" label="账号" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="name" label="姓名" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
      <el-table-column prop="education" label="学历">
      </el-table-column>
      <el-table-column prop="occupation" label="职业" width=""></el-table-column>
      <el-table-column prop="phone" label="联系方式">
      </el-table-column>
       <el-table-column prop="istrue" label="审核状态">
        <template slot-scope="scope">
          <span style="color:#05C94F" v-if="scope.row.IsPost==1">审核通过</span>
          <span style="color:#E53939" v-if="scope.row.IsPost==2">审核不通过</span>
          <span style="color:#2D82FF" v-if="scope.row.IsPost==0">待审核</span>
        </template>
      </el-table-column>
      <el-table-column prop="istrue" label="申报类型">
        <template slot-scope="scope">
          <span v-if="scope.row.Type==1">培训讲师</span>
          <span v-if="scope.row.Type==2">考评员</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="edit(scope.row.id,scope.row.Type)"
            title="编辑"
            v-if="scope.row.IsPost == 0"
          >编辑</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="goView(scope.row.id,scope.row.Type)"
            title="查看"
             v-else
          >查看</el-button>
          <!-- <a :href="exportHref + scope.row.id" class="export-table-btn">导出申请表</a> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="pageIndex"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        v-show="total>0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      SiteList: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      viewNoticeVisible: false,
      dialogVisibleAudit:false,
      /* -----------添加/修改弹框参数------------ */
      title: "",
      content: "",
      avatorUrl: "",
      newsType: 1,
      orderNumber: 0,
      pulishTime: "",
      /* --------------------------------------- */
      id: "",
      siteId: "",
      siteName: "",
      value: "",
      teacherId:'',

      materialInfo: [],
      imgsList: [],
      indexCount: 0,
      imgUrl: "",
      dialogVisiblePreviewResources: false,
      IsAuthentication:1,
      reason:'',
      TrainApplyId:"",
      exportHref:'/api/XOrg/TrainApply/eportTrainApply?TrainApplyId='
    };
  },
  created() {
    this.school = this.$store.state.auth.userName;
    this.getTrainApplyList();
  },
  props: {
    certificateId:{
      type:String,
      default:""
    }
  },
  methods: {
    getTrainApplyList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/TrainApply/getTrainApplyList", {
          page: page,
          pageSize: this.pageSize,
          name: that.title,
          certificateId: this.certificateId
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    cancel() {
      this.dialogVisibleAudit = false,
      this.reason =''
    },
    // 编辑
    edit(id,type) {
       this.$router.push({
         name:'applyTableEdit',
         params:{
           userId:id,
           userType:type,
           url:"TrainApplyManager",
           pageSize:'10',
           pageIndex:'1'
         }
       });
    },
     // 查看
    goView(id,type) {
       this.$router.push({
         name:'applyTableDetail',
         params:{
           userId:id,
           userType:type
         }
       });
    },
    onPageChangeHandler(page) {
      this.getTrainApplyList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTrainApplyList();
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    },
    viewSchoolNews(row) {
      this.title = row.title;
      this.content = row.content;
      this.viewNoticeVisible = true;
    },
    search() {
      this.getTrainApplyList(1);
    }
  }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper{
  .export-table-btn{
      margin-left: 10px;
      color: #fff;
      padding: 7px 15px;
      background-color: #409eff;
      border-radius: 3px;
      font-size: 12px;
  }
}
</style>

